import { useAuth } from "../auth/AuthContext";

/** Date of the current privacy notice and terms of use (matches the notice version "2026-10-03"). */
export const LEGAL_UPDATED = "3 October 2026";

/** Used while GET /api/auth/state hasn't answered, or if an older backend doesn't send it. */
export const DEFAULT_PRIVACY_CONTACT = "privacidad@nabble.cl";

export const PRIVACY_PATH = "/legal/privacy";
export const TERMS_PATH = "/legal/terms";

/** Where people write about their personal data, from GET /api/auth/state. */
export function usePrivacyContact(): string {
  const { state } = useAuth();
  return state?.privacyContact?.trim() || DEFAULT_PRIVACY_CONTACT;
}
